// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".button{background-color:#a62626;border:none;border-radius:100px;color:#fff;cursor:pointer;display:inline-block;font-size:.875rem;font-weight:500;padding:.75rem 3rem;transition:all .2s ease}@media(min-width:64em){.button{font-size:1.125rem;padding:1.1875rem 4rem}}.button:hover{background-color:#7d1d1d}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
